
import { useMutation, useQueryClient} from 'react-query'; 
import { useContext } from 'react';
import { AuthContext } from '../../../Context/AuthContext';
import { useNavigate } from 'react-router-dom';

const useDeleteTruck = () => {
  const queryClient = useQueryClient();
  const { token } = useContext(AuthContext); 
  const navigate = useNavigate(); 

  const deleteTruck = useMutation(
    async (id) => {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/freight/delete-trucks/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`, 
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to delete Truck');
      }

      return response.json();
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('freighttruck');
        navigate('/freighttruck'); 
      },
    }
  );

  return {
    deleteTruck,
    isLoading: deleteTruck.isLoading,
     error: deleteTruck.error,
  };
};

export default useDeleteTruck;

